<template>
    <div class="vh-flex mpanel" v-loading="showLoading">
        <el-scrollbar class="vh-full">
            <div class="inrect">
                <!--卡片-->
                <div class="strcard">
                    <div>
                        <h1 class="lbunitname">{{ selectUnit.unitName }}</h1>
                        <div v-if="selectUnit.learnCount == 0" class="lbstatus">未开始学习</div>
                        <div v-else class="lbstatus">
                            <span>最近学习</span>
                            <span>{{ calcAgoTime(selectUnit.lastLearnTime) }}</span>
                            <span class="mgsp1">●</span>
                            <span>累计学时</span>
                            <span>{{ learnMinuteTime }}</span>
                            <span>分钟</span>
                        </div>
                        <!--未学习按钮组-->
                        <div v-if="selectUnit.learnCount == 0" class="vc-flex mgt20">
                            <div @click="openLearnApp('order')" class="bntlearn focus-s">
                                <SvgIcon svgname="ic_learn" :size="18" fill="#4d5bff"></SvgIcon>
                                <span class="mgl5">开始学习</span>
                            </div>
                        </div>
                        <div v-else class="vc-flex mgt20">
                            <div @click="openLearnApp('order')" class="bntlearn focus-s">
                                <SvgIcon svgname="ic_run" :size="18" fill="#4d5bff"></SvgIcon>
                                <span class="mgl5">继续学习 {{ orderSeqNo }}/{{ orderTotalCount }}</span>
                            </div>
                            <div @click="openLearnApp('reorder')" class="bntlearn focus-s">
                                <SvgIcon svgname="ic_loop" :size="18" fill="#4d5bff"></SvgIcon>
                                <span class="mgl5">重头开始</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <DoubleCircleProgress :value1="learnProgress" :value2="masterProgress" color1="#5C81FF"
                            color2="#EA47FF" :size="120" :strokeWidth="13" />
                    </div>
                </div>

                <!--卡片区域-->
                <div class="cards-grid">
                    <div class="card-column">
                        <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">句子总数</span>
                                <span class="icon">📘</span>
                            </div>
                            <div class="card-value">{{ totalCount }}</div>
                        </div>
                        <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">我的收藏</span>
                                <span class="icon" style="background: rgb(0 255 206 / 14%);">
                                    <i class="fa fa-star" style="color: rgb(0 255 222);"></i>
                                </span>
                            </div>
                            <div class="card-value">{{ collectCount }}</div>
                            <div class="vc-flex">
                                <IconMenu @click="openLearnApp('collect')" svgname="ic_run" name="强化学习" :iconSize="13"></IconMenu>
                            </div>
                        </div>
                    </div>
                    <div class="card-column">
                        <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">已学习</span>
                                <span class="icon"
                                    style="background:rgba(22,163,74,0.12); color:var(--success);">✅</span>
                            </div>
                            <div class="card-value">{{ learnedCount }}</div>
                        </div>
                        <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">低评分数量</span>
                                <span class="icon">
                                    <i class="fa fa-thumbs-down" style="color: rgb(255 0 0);"></i>
                                </span>
                            </div>
                            <div class="card-value">{{ lowerScoreCount }}</div>
                            <div class="vc-flex">
                                <IconMenu @click="openLearnApp('lowerScore')" svgname="ic_run" name="强化学习" :iconSize="13"></IconMenu>
                            </div>
                        </div>
                    </div>
                    <div class="card-column">
                        <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">已掌握</span>
                                <span class="icon" style="background: #ff00f32b;">📘</span>
                            </div>
                            <div class="card-value">{{ masterCount }}</div>
                        </div>
                        <!-- <div class="stat-card">
                            <div class="card-header">
                                <span class="card-tip">总句子数量</span>
                                <span class="icon">📘</span>
                            </div>
                            <div class="card-value">120</div>
                        </div> -->
                    </div>
                </div>




            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import httpClient from '@/commom/http/httpClient';
import localCache from '@/commom/local/LocalCache';
import DoubleCircleProgress from '@/components/DoubleCircleProgress.vue';
import dateTimeHelper from '@/commom/date/DateTimeHelper.js';
import IconMenu from '@/components/IconMenu.vue';

export default {
    name: 'UnitOverview',
    components: {
        SvgIcon,
        DoubleCircleProgress,
        IconMenu
    },
    props: {
        bookInfo: Object,
        selectUnit: Object
    },
    watch: {
        selectUnit: function (nval, old) {
            if (nval != null) {
                this.loadData()
            }
        }
    },
    data() {
        return {
            showLoading: false,
            totalCount: 0,
            learnedCount: 0,
            masterCount: 0,
            collectCount: 0,
            lowerScoreCount: 0,
            learnMinuteTime: 0,
            orderSeqNo: 0,
            orderTotalCount: 0,
            learnProgress: 0,
            masterProgress: 0
        }
    },
    mounted: function () {
        if (this.selectUnit != null) {
            this.loadData()
        }

    },
    methods: {
        ///加载数据
        loadData: function () {
            this.showLoading = true
            var that = this
            var req = {
                bookId: that.bookInfo.bookId,
                unitId: that.selectUnit.unitId
            }
            httpClient.invoke("BookUnitAPI.GetOverviewData", req, function (res) {
                console.log("统计数据", res)
                that.showLoading = false
                if (res.error) {
                    that.$message.error(res.error.message)
                    return
                }
                that.totalCount = res.totalCount
                that.learnedCount = res.learnedCount
                that.masterCount = res.masterCount
                that.collectCount = res.collectCount
                that.lowerScoreCount = res.lowerScoreCount
                that.learnMinuteTime = Math.round(res.learnTime / 60)
                that.orderSeqNo = res.orderSeqNo
                that.orderTotalCount = res.orderTotal
                that.learnProgress = Math.round(res.learnedCount / res.totalCount * 100)
                that.masterProgress = Math.round(res.masterCount / res.totalCount * 100)
            })
        },
        ///计算时间 ago 显示文本
        calcAgoTime: function (strTime) {
            return dateTimeHelper.calcAgoShowTime(strTime)
        },
        ///打开学习app
        openLearnApp: function (learnType) {
            var that = this

            var req = {
                bookId: that.bookInfo.bookId,
                unitId: that.selectUnit.unitId,
                learnType: learnType
            }
            this.showLoading = true
            httpClient.invoke("LearnAPI.GetLearnIndex", req, function (res) {
                console.log("返回结果", res)
                that.showLoading = false
                if (res.error) {
                    that.$message.error(res.error.message)
                    return
                }
                if (res.listId.length == 0) {
                    that.$message({ message: "没有可学习的数据" });
                    return
                }
                var learnModel = {
                    learnInfo: res,
                    learnType: learnType,
                    bookInfo: that.bookInfo,
                    unitInfo: that.selectUnit
                }
                localCache.setObject("learnModel", learnModel)
                that.$router.push("/spell-word-tools")
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cards-grid {
    margin-top: 32px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 26px;
}

@media (max-width: 1200px) {
    .cards-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .cards-grid {
        grid-template-columns: 1fr;
    }
}

.card-column {
    display: grid;
    gap: 18px;
}

.stat-card {
    background: var(--card-bg);
    border-radius: var(--radius-md);
    padding: 22px;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    border: 1px solid rgba(148, 163, 184, 0.14);
    transition: var(--transition);
    display: grid;
    gap: 12px;
    border-radius: 15px;
}

.card-tip {
    color: var(--ek-text-color2);
}

.card-value {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--ek-text-color1);
}

.card-header .icon {
    width: 38px;
    height: 38px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    background: rgba(37, 99, 235, 0.12);
    color: var(--primary);
    font-size: 1.1rem;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.95rem;
    color: var(--muted);
}



.strcard {
    background: var(--ek-unit-overview-bar);
    color: #ffffff;
    padding: 32px;
    border-radius: 24px;
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 28px;
}

.strcard::after {
    content: "";
    position: absolute;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    right: -40px;
    top: -40px;
    filter: blur(0.5px);
}

.lbunitname {
    font-size: 2rem;
    letter-spacing: 0.02em;
}

.lbstatus {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;
}

.mgsp1 {
    margin-left: 10px;
    margin-right: 10px;
}

.bntlearn {
    background: white;
    color: #4d5bff;
    display: flex;
    height: 40px;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    border-radius: 20px;
    font-size: 15px;
    font-weight: bold;
    margin-right: 20px;
}

.learn-title {
    color: var(--ek-text-color1);

}

.learn-item {
    display: flex;
    align-items: center;
    background: var(--ek-card-progress-bgColor);
    min-width: 250px;
    height: 80px;
    padding-left: 20px;
    border-radius: 10px;
    margin-right: 20px;
}

.mpanel {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;

}

.stitle {
    color: var(--ek-text-color2);
    font-size: 14px;
}

.btitle {
    font-size: 13px;
    color: var(--ek-text-color2);
}

.num {
    font-size: 20px;
    font-weight: bold;
    color: var(--ek-text-color1);
}

.sunit {
    font-size: 13px;
    margin-left: 3px;
    color: var(--ek-text-color2);
}

.num-item {
    min-width: 170px;
    border-right: 1px solid var(--ek-split-lineColor);
    padding-top: 10px;
    padding-bottom: 10px;
}

.sm1 {
    margin-top: 30px;
}

.sprgm {
    min-width: 170px;
    border-right: 1px solid var(--ek-split-lineColor);
    margin-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.pnum {
    font-weight: bold;
    color: var(--ek-text-color1);
}
</style>
